ACC.configureLanguage = {

  bindAll: function() {
    $('.ph-configurelanguagelink, .ph-changelanguagelink').on('click', this.handleChangconfigureLanguageButtonClick);

    // Removing the terms and conditions
    $(document).on('change', '.radioselect', function() {
      $('.ph-termsandconditions').show();
      $('.ph-selectlanguagebutton').addClass('ph-disabledbutton ');
      $('.ph-selectlanguagebutton').removeClass('ph-orangebutton');
      $('#termsaandcondition-checkbox').removeAttr('checked');
    });

    $(document).on('change', '.deafultselected', function() {
      $('.ph-termsandconditions').hide();
      $('.ph-selectlanguagebutton').addClass('ph-orangebutton');
      $('.ph-selectlanguagebutton').removeClass('ph-disabledbutton');
    });

    $(document).on('click', '.ph-selectlanguagebutton', function() {
      $('.ph-configurelanguagelink').hide();
      $('.ph-changelanguagelink, .ph-selectedlanguagelink').show();
    });

    $(document).on('click', '#termsaandcondition-checkbox', function() {
      $('.ph-selectlanguagebutton').toggleClass('ph-orangebutton');
      $('.ph-selectlanguagebutton').toggleClass('ph-disabledbutton');
    });

    $(document).on('click', '.ph-cartTermsandCondition', function() {
      ACC.termsandconditions.bindTermsAndConditionsLink();
    });


    $(document).on('click', '.ph-selectlanguagebutton', function() {
      ACC.configureLanguage.handleSelectExistingAddressClick();
    });
  },

  handleChangconfigureLanguageButtonClick: function() {
    $.getJSON($('.ph-getZUAddressessUrl').text(), ACC.configureLanguage.handleconfigureLanguageDataLoad);
  },


  handleconfigureLanguageDataLoad: function(data) {
    var popUpContent = ACC.configureLanguage.setupconfigureLanguagePopupForm(data);

    $('.languagePopupParent').html(popUpContent);

    // Displaying popup

    $.colorbox({
      maxHeight: 450,
      html: $('.languagePopupParent').html(),
      onComplete: function() {
        for (var i = 0; i < data.zuAddressses.length; i = i + 1) {
          if (data.zuAddressses[i].langSelected === true && data.siteLanguage === data.zuAddressses[i].language) {
            $('#cboxContent .radioselect[data-langId=' + data.zuAddressses[i].addressId + ' ]').attr('checked', 'checked');
            $('#cboxContent .radioselect[data-langId=' + data.zuAddressses[i].addressId + ' ]').addClass('deafultselected');
            $('.ph-termsandconditions').hide();
            $('.ph-selectlanguagebutton').addClass('ph-orangebutton');
            $('.ph-selectlanguagebutton').removeClass('ph-disabledbutton');
          } else if (data.zuAddressses[i].langSelected === true) {
            $('#cboxContent .radioselect[data-langId=' + data.zuAddressses[i].addressId + ' ]').attr('checked', 'checked');
          } else if (data.siteLanguage === data.zuAddressses[i].language) {
            $('#cboxContent .radioselect[data-langId=' + data.zuAddressses[i].addressId + ' ]').addClass('deafultselected');
          }
        }

        ACC.common.refreshScreenReaderBuffer();
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },

  setupconfigureLanguagePopupForm: function(data) {
    var a = '';

    for (var i = 0; i < data.zuAddressses.length; i = i + 1) {
      a = a + ('<input type = "radio" id="language1" class="radioselect" name="language" data-langId="' + data.zuAddressses[i].addressId + '"> <label class="languages">' + data.zuAddressses[i].language + '</label></br>');
    }

    return '<div class="ph-languagepopup"><h2 class="ph-languageheader">' + $('.confhead').html() + '</h2><div class="ph-languagedescription">' + $('.confdetails').html() + '</div><div class="languageselection"><h3 class="selectlanguageheader">' + $('.langhead').html() + '</h3>' + a + '</div><div class="ph-termsandconditions"><input type="checkbox" id="termsaandcondition-checkbox" class="termsaandcondition-checkbox1"><span>' + $('.terms').html() + '</span></div><div class="ph-submitbutton"><button class="ph-selectlanguagebutton ph-disabledbutton">Select language</button></div></div> ';
  },

  handleSelectExistingAddressClick: function() {
    ACC.configureLanguage.handleconfigureLanguageSuccess();
  },

  handleconfigureLanguageSuccess: function() {
    var selectedAddressId = '';

    $('#cboxContent .radioselect').each(function() {
      if ($(this).prop('checked')) {
        selectedAddressId = $(this).attr('data-langId');
      }
    });
    $.ajax({
      url: $('.ph-setSelectedZUAddressess').text(),
      data: {
        zuAddressId: selectedAddressId
      },
      type: 'POST',
      datatype: 'json',
      success: function() {
        window.location.reload();
      }
    });
  }
};

$(document).ready(function() {
  ACC.configureLanguage.bindAll();
});

